import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyNBMPage: LoadableType<
	Omit<
		{
			scanId?: string;
		},
		'flags'
	>
> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-NBMPage" */ './NBMPage.tsx')).NBMPage,
});
